// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__rsqZp","hiddenElements":"Header_hiddenElements__7U6Pu","search":"Header_search__32sZz","dark":"Header_dark__3jcxP","wrapper":"Header_wrapper__2VImQ"};